export interface ActionTrackings {
  txnUuid: string;
  actionTrackings: EventTracking[];
}

export interface ActionTrackingUI {
  loaded: boolean;
}

export enum StandardEventTracking {
  assigned = 'assigned',
  created = 'created',
  mentioned = 'mentioned',
  watched = 'watched'
}

export enum CustomEventTracking {
  customerMsg = 'customerMsg', //cust lc, cust wa,cust comment in submitted ticket
  agentMsg = 'agentMsg', //agent comment in submitted ticket
  internalMentioned = 'internalMentioned' //mention in internal discussion
}

export type EventTracking = StandardEventTracking | CustomEventTracking;

export type ActionTrackingsResponse = Map<EventTracking, string[]>;
